import { ChevronLeft, ChevronRight } from "lucide-react"
import { useRef, useEffect, useState } from "react"

const IMAGES = [
  "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9Filows2734notj1daOZW8ixGuckNIgXvfRPp",
  "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9pp0jzeEfqR83wQxCZB9mau0bU4YJrXgLH1Wl",
  "https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9mTC79P8BESupc3KwDzo4tbeGVHYWUAdQyl5j",
]

export function ImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAutoPlay, setIsAutoPlay] = useState(true)
  const carouselRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isAutoPlay) return

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % IMAGES.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [isAutoPlay])

  const handlePrevious = () => {
    setIsAutoPlay(false)
    setCurrentIndex((prev) => (prev - 1 + IMAGES.length) % IMAGES.length)
  }

  const handleNext = () => {
    setIsAutoPlay(false)
    setCurrentIndex((prev) => (prev + 1) % IMAGES.length)
  }

  return (
    <div className="relative md:hidden">
      {/* Carousel Container */}
      <div ref={carouselRef} className="overflow-hidden rounded-2xl shadow-2xl">
        <div
          className="flex transition-transform duration-700 ease-out"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {IMAGES.map((image, index) => (
            <div key={index} className="w-full flex-shrink-0">
              <div className="relative h-96 md:h-[500px] bg-gray-100 overflow-hidden group">
                <img
                  src={image || "/placeholder.svg"}
                  alt={`Carousel image ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons */}
      <button
        onClick={handlePrevious}
        className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-12 md:-translate-x-16 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300 z-10 group"
        aria-label="Previous image"
      >
        <ChevronLeft className="w-6 h-6 group-hover:scale-110 transition-transform" />
      </button>

      <button
        onClick={handleNext}
        className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-12 md:translate-x-16 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300 z-10 group"
        aria-label="Next image"
      >
        <ChevronRight className="w-6 h-6 group-hover:scale-110 transition-transform" />
      </button>

      {/* Dot Indicators */}
      <div className="flex justify-center gap-2 mt-8">
        {IMAGES.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              setIsAutoPlay(false)
              setCurrentIndex(index)
            }}
            className={`transition-all duration-300 rounded-full ${
              index === currentIndex ? "bg-white w-8 h-2" : "bg-white/40 hover:bg-white/60 w-2 h-2"
            }`}
            aria-label={`Go to image ${index + 1}`}
            aria-current={index === currentIndex ? "true" : "false"}
          />
        ))}
      </div>
    </div>
  )
}
